import FILTER_TYPES from '@/components/query/filter-types';

export default {
    id: 'webhook-tracking-logs',
    version: 1,
    filterSpec: {
        id: {
            type: FILTER_TYPES.text,
        },
        eventType: {
            type: FILTER_TYPES.text,
        },
        url: {
            type: FILTER_TYPES.text,
        },
        method: {
            type: FILTER_TYPES.text,
        },
        responseCode: {
            type: FILTER_TYPES.text,
        },
        attempt: {
            type: FILTER_TYPES.numeric,
        },
        source: {
            type: FILTER_TYPES.text,
        },
        createdTime: {
            type: FILTER_TYPES.datetime,
        },
        sentTime: {
            type: FILTER_TYPES.datetime,
        },
        headers: {
            type: FILTER_TYPES.text,
        },
        payload: {
            type: FILTER_TYPES.text,
        },
        responseBody: {
            type: FILTER_TYPES.text,
        },
        initiatedTime: {
            type: FILTER_TYPES.datetime,
        },
        entityId: {
            type: FILTER_TYPES.text,
            label: 'Related Entity Id',
        },
    },
};
